import DropdownSelect from 'trunks/vue/admin/components/libs/dropdown_select.js';
import ControlableFieldsPopover from './controlable_field_popover.js';

const mixins = {
  components: {
    'dropdown-select': DropdownSelect,
    'controlable-fields-popover': ControlableFieldsPopover
  },

  props: {
    logic: {
      type: Object
    },
    controlableFields: {
      type: Array,
      default: function() {
        return [];
      }
    },
    possibleFields: {
      type: Array,
      default: function() {
        return [];
      }
    },
    logicable: {
      type: Boolean,
      default: true
    }
  },

  data: function() {
    return {
      editing: false,
      valid: true,
      invalid_ids: []
    };
  },

  created: function() {
    this.$emit('childAdded', this);
    this.$_init();
    this.$nextTick(function() {
      this.valid = this.checkValid();
    });
  },

  watch: {
    editing: function(new_value) {
      this.$emit('editingChanged', new_value);
      if (!new_value) {
        this.$emit('updateSetting');
        this.valid = this.checkValid();
      }
    }
  },

  methods: {
    toggleControlField: function(event, field) {
      var checked, some_fields_selected;

      checked = event.target.checked;
      if (checked) {
        this.fieldIds.push(field.id);
        // 选中明细时，如果明细内都没选中，则全选明细内的字段
        if (field.type === 'Field::Detail') {
          some_fields_selected = _.some(field.children, (child) => _.contains(this.fieldIds, child.id));
          if (!some_fields_selected) {
            this.fieldIds = this.fieldIds.concat(_.pluck(field.children, 'id'));
          }
        }
      } else {
        this.fieldIds = _.without(this.fieldIds, field.id);
        // 取消明细内的最后一个字段时，取消明细字段
        if (field.detail_id) {
          some_fields_selected = _.some(field.detail.children, (child) => _.contains(this.fieldIds, child.id));
          if (!some_fields_selected) {
            this.fieldIds = _.without(this.fieldIds, field.detail_id);
          }
        }
      }
    },

    popoverBackdropClosed: function(event) {
      this._removeInvalidLogicFields();
      if (!this.$el.contains(event.target)) {
        this.editing = false;
        Skylark.Helpers.App.removeCapturedBackdropByID(this._backdrop_id);
        this.$emit('afterBackdropClose', event);
      }
    },

    _enableBackdrop: function() {
      this._backdrop_id = Skylark.Helpers.App.capturedBackdrop((event) => {
        this.editing = false;
      }, this.$el);
    },

    _removeInvalidLogicFields: function() {
      this.fieldIds = _.difference(this.fieldIds, this.invalid_ids);
      this.valid = this.checkValid();
      this.$emit('updateSetting');
    },

    _clearRemovedField: function() {
      this.fieldIds = _.filter(this.fieldIds, (id) => _.some(this.possibleFields, (field) => {
        if (field.id === id) {
          return true;
        }
        if (field.type === 'Field::Detail') {
          return _.some(field.children, (child) => child.id === id);
        } else {
          return false;
        }
      }));
    },

    _checkFieldValid: function(field_id) {
      return _.some(this.controlableFields, (field) => {
        if (field.id === field_id) {
          return true;
        }
        if (field.type === 'Field::Detail') {
          return _.some(field.children, (child) => child.id === field_id);
        } else {
          return false;
        }
      });
    }
  }
};

const rangeMixin = {
  props: {
    limitMax: {
      type: Number
    }
  },

  data: function() {
    return {
      mode: 'lteq',
      from: '',
      to: ''
    };
  },

  computed: {
    modeIsWithin: function() {
      return this.mode === 'in';
    },

    rangeText: function() {
      if (this.modeIsWithin) {
        return `${this.from} ~ ${this.to}`;
      } else {
        return this.from;
      }
    },

    rangeValue: function() {
      if (this.modeIsWithin) {
        return [this.from, this.to];
      } else {
        return this.from;
      }
    },

    rangeValid: function() {
      if (!this.limitMax) {
        return true;
      }
      switch (this.mode) {
        case 'eq':
          return Boolean(0 <= Number(this.from) && Number(this.from) <= this.limitMax);
        case 'gt':
          return Boolean(Number(this.from) < this.limitMax);
        case 'lt':
          return Boolean(0 < Number(this.from));
        case 'gteq':
          return Boolean(Number(this.from) <= this.limitMax);
        case 'lteq':
          return Boolean(0 <= Number(this.from));
        case 'in':
          return Boolean(this.from <= this.limitMax) && Boolean(0 <= Number(this.to));
        default:
          return true;
      }
    }
  },

  methods: {
    checkValid: function() {
      this.invalid_ids = [];
      _.each(this.fieldIds, (id) => {
        var result;

        result = this._checkFieldValid(id);
        if (!result) {
          this.invalid_ids.push(id);
        }
      });
      return _.isEmpty(this.invalid_ids) && this.rangeValid;
    },

    modeChangeFunc: function(option) {
      if (this.mode === option) {
        return;
      }
      this.mode = option;
    },

    _translateModeIfNeed: function() {
      if (this.modeIsWithin) {
        if (!(this.from || this.to)) {
          return;
        }
        if (this.from && !this.to) {
          this.modeChangeFunc('gteq');
        } else if (this.to && !this.from) {
          [this.from, this.to] = [this.to, this.from];
          this.modeChangeFunc('lteq');
        } else if (this.from === this.to) {
          this.modeChangeFunc('eq');
        } else {
          if (Number(this.from) > Number(this.to)) {
            [this.from, this.to] = [this.to, this.from];
          }
        }
      } else {
        if (!this.from) {
          return;
        }
      }
      return true;
    }
  }
};

const LogicalOption = {
  mixins: [mixins],

  props: {
    option: {
      type: Object,
      required: true
    },
    icon: String
  },

  data: function() {
    return {
      fieldIds: []
    };
  },

  template: `
    <div class="option-item justify-box vertical-top"
         @click='enableEditIfNeed'
         :class="{ editing: editing, 'other-option': option.id === 0 }">
      <div class="content logic-option-area justify-box">
        <input type="checkbox" hidden='true' :checked='editing' />
        <i :class="icon"></i>
        <span class="option-label">{{ option.value }}</span>
        <div class="other-input">
          <input type="text" readonly v-if='option.id === 0' placeholder='请输入' />
        </div>
      </div>
      <div class="content justify-box vertical-top logic-setting-container">
        <span v-show='fieldIds.length || editing'>就显示</span>
        <controlable-fields-popover :editing='editing'
                                    customClass='content'
                                    :controlableFields='controlableFields'
                                    :possibleFields='possibleFields'
                                    :fieldIds='fieldIds'
                                    :valid='valid'
                                    @toggleControlField='toggleControlField'
                                    @popoverBackdropClosed='popoverBackdropClosed' />
        <span class="btn btn-danger text-btn" v-show='editing && fieldIds.length' @click='removeLogic'>删除</span>
      </div>
    </div>
  `,

  methods: {
    enableEditIfNeed: function(event) {
      if (this.editing) {
        return;
      }
      if (!this.logicable) {
        return;
      }
      this.editing = true;
      this._enableBackdrop();
    },

    checkValid: function() {
      this.invalid_ids = [];
      _.each(this.fieldIds, (id) => {
        var result;

        result = this._checkFieldValid(id);
        if (!result) {
          this.invalid_ids.push(id);
        }
      });
      return _.isEmpty(this.invalid_ids);
    },

    removeLogic: function() {
      this.fieldIds = [];
      this.$emit('updateSetting');
    },

    getLogicSetting: function() {
      return {
        type: 'inclusion',
        in: [this.option.id],
        field_ids: this.fieldIds
      };
    },

    _removeInvalidLogic: function() {
      this._removeInvalidLogicFields();
    },

    $_init: function() {
      this.fieldIds = this.logic.field_ids || [];
    }
  }
};

const RangeLogicalOption = {
  mixins: [mixins, rangeMixin],

  props: {
    allowedLogicMode: {
      type: Array,
      default: function() {
        return ['eq', 'gt', 'lt', 'gteq', 'lteq', 'in'];
      }
    }
  },

  data: function() {
    return {
      fieldIds: []
    };
  },

  template: `
    <div class="option-item range-option justify-box vertical-top"
        :class="{ 'editing': editing }"
        @click='enableEditIfNeed'>
      <div class="content justify-box logic-option-area">
        <template v-if='editing'>
          <span>输入值</span>
          <dropdown-select :optionGroups='[{ options: allowedLogicMode }]'
                          :initValue='mode'
                          customClass='transparent'
                          @change='modeChangeFunc'
                          v-show='editing'>
            <template slot='value-template' slot-scope='{ option }'>
              <span>{{ Skylark.Helpers.getZH_CN('field.logic.range.' + option) }}</span>
            </template>
            <template slot='option-template' slot-scope='{ option }'>
              <span>{{ Skylark.Helpers.getZH_CN('field.logic.range.' + option) }}</span>
            </template>
          </dropdown-select>
          <div class="content range-input-container vertical-middle">
            <input type='number' v-model='from'>
            <template v-if="mode == 'in'">
              <span class="divider">到</span>
              <input type='number' v-model='to'>
            </template>
          </div>
        </template>
        <div :class="{ 'error-text': !rangeValid }" v-else>
          <span>{{ Skylark.Helpers.getZH_CN('field.logic.range.' + mode) }}</span>
          <span class="range-input-container">{{ rangeText }}</span>
        </div>
      </div>
      <div class="content justify-box vertical-top logic-setting-container">
        <span v-show='fieldIds.length || editing'>就显示</span>
        <controlable-fields-popover :editing='editing'
                                    customClass='content'
                                    :controlableFields='controlableFields'
                                    :possibleFields='possibleFields'
                                    :fieldIds='fieldIds'
                                    :valid='valid'
                                    @toggleControlField='toggleControlField'
                                    @popoverBackdropClosed='popoverBackdropClosed' />
        <span class="btn btn-danger text-btn" v-show='editing' @click='removeLogic'>删除</span>
      </div>
    </div>
  `,

  methods: {
    enableEditIfNeed: function(event) {
      event?.stopPropagation();
      if (this.editing) {
        return;
      }
      if (!this.logicable) {
        return;
      }
      this.editing = true;
      this._enableBackdrop();
    },

    removeLogic: function() {
      this.$emit('removeLogic', this);
    },

    getlogicSetting: function() {
      var result;

      if (_.isEmpty(this.fieldIds)) {
        return;
      }
      if (!this._translateModeIfNeed()) {
        return;
      }

      result = {};
      result[this.mode] = this.rangeValue;
      return _.extend(result, {
        type: 'range',
        field_ids: this.fieldIds
      });
    },

    _removeInvalidLogic: function() {
      if (!this.rangeValid) {
        this.removeLogic();
      } else {
        this._removeInvalidLogicFields();
      }
    },

    $_init: function() {
      this.mode = (_.intersection(this.allowedLogicMode, _.keys(this.logic))[0]) || 'lteq';
      this.from = this.modeIsWithin ? (this.logic[this.mode])[0] : this.logic[this.mode];
      this.to = this.modeIsWithin ? (this.logic[this.mode])[1] : '';
      this.fieldIds = this.logic.field_ids || [];
    }
  }
};

const TextRangeOption = {
  mixins: [mixins, rangeMixin],

  props: {
    initialRange: {
      type: Object,
      default: function() {
        return {};
      }
    },
    allowedTextRangeMode: {
      type: Array
    },

    allowFloat: {
      type: Boolean,
      default: true
    }
  },

  template: `
    <div class="range-option justify-box vertical-middle"
        :class="{ 'editing': editing }"
        @click='enableEditIfNeed'>
      <div class="content justify-box logic-option-area">
        <template v-if='editing'>
          <slot name="option-title-template"></slot>
          <dropdown-select :optionGroups='[{ options: allowedTextRangeMode }]'
                          :initValue='mode'
                          customClass='transparent'
                          @change='modeChangeFunc'
                          v-show='editing'>
            <template slot='value-template' slot-scope='{ option }'>
              <span>{{ Skylark.Helpers.getZH_CN('field.logic.range.' + option) }}</span>
            </template>
            <template slot='option-template' slot-scope='{ option }'>
              <span>{{ Skylark.Helpers.getZH_CN('field.logic.range.' + option) }}</span>
            </template>
          </dropdown-select>
          <div class="content range-input-container vertical-middle">
            <input type='number' v-model='from'>
            <template v-if="mode == 'in'">
              <span class="divider">到</span>
              <input type='number' v-model='to'>
            </template>
          </div>
        </template>
        <div  class="vertical-middle" :class="{ 'error-text': !rangeValid }" v-else>
          <slot name="option-title-template"></slot>
          <span v-if='rangeText' class="vertical-middle ml-1">
            {{ Skylark.Helpers.getZH_CN('field.logic.range.' + mode) }}
            <span class="range-input-container">{{ rangeText }}</span>
          </span>
        </div>
      </div>
    </div>
  `,

  methods: {
    enableEditIfNeed: function(event) {
      event?.stopPropagation();
      if (this.editing) {
        return;
      }
      this.$emit('optionOpen', event);
      this.$nextTick(() => {
        this.editing = true;
        this._enableBackdrop();
      });
    },

    setValue: function() {
      if (!this.allowFloat) {
        this.from = this._formatNumber(Number(this.from));
        this.to = this._formatNumber(Number(this.to));
      }

      this._translateModeIfNeed();
      this.$emit('rangeChanged', this.from, this.to, this.mode);
    },

    _formatNumber: function(num) {
      if (num > 0) {
        return Math.round(num);
      } else {
        return '';
      }
    },

    _enableBackdrop: function() {
      this._backdrop_id = Skylark.Helpers.App.capturedBackdrop((event) => {
        this.setValue();
        this.$emit('afterBackdropClose', event);
        this.editing = false;
      }, this.$el);
    },

    $_init: function() {
      if (this.initialRange) {
        this.mode = (_.intersection(this.allowedTextRangeMode, _.keys(this.initialRange))[0]) || 'lteq';
        this.from = this.modeIsWithin ? (this.initialRange[this.mode])[0] : this.initialRange[this.mode];
        this.to = this.modeIsWithin ? (this.initialRange[this.mode])[1] : '';
      }
    }
  }
};

export { LogicalOption, RangeLogicalOption, TextRangeOption };
